import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import { useLang } from "../../../Hooks";
import { ReportHeader } from "../Shared/Components/ReportHeader";
import { ReportToolbar } from "../Shared/Components/ReportToolbar";
import { reportToolbarStyles } from "../Shared/Styles/reportToolbarStyles";
import { useStructuralRatiosData } from "./hooks/useStructuralRatiosData";
import { StructuralRatiosActions } from "./Components/StructuralRatiosActions";
import { StructuralRatiosFilters } from "./Components/StructuralRatiosFilters";
import { StructuralRatiosTable } from "./Components/StructuralRatiosTable";

export default function StructuralRatios() {
  const { texts } = useLang();
  const {
    applyFilters,
    changeCurrency,
    exportReport,
    filters,
    isExporting,
    isLoadingReport,
    reportData,
    toggleRow,
  } = useStructuralRatiosData();

  return (
    <Box p={0}>
      <Flex {...reportToolbarStyles.headerRow}>
        <ReportHeader
          title={texts.reports?.structuralRatios || "Structural Ratios"}
          subtitle={texts.reports?.financialOverview || "Financial overview"}
        />
        <ReportToolbar>
          <StructuralRatiosFilters
            currentFilters={filters}
            onApplyFilters={applyFilters}
            onCurrencyChange={changeCurrency}
          />
          <StructuralRatiosActions isExporting={isExporting} onExport={exportReport} />
        </ReportToolbar>
      </Flex>
      <StructuralRatiosTable data={reportData} isLoading={isLoadingReport} onToggleRow={toggleRow} />
    </Box>
  );
}
